interface RequestError {
  heading: string;
  description: string;
}

const VALIDATION_ERRORS: Record<string, RequestError> = {
  "Upload limit reached": {
    heading: "Upload limit reached",
    description: "The maximum number of uploads for this request has been reached.",
  },
  "Request has expired": {
    heading: "This link has expired",
    description:
      "This document request link has expired. Ask the person who sent it to create a new one.",
  },
  "Request is no longer active": {
    heading: "This link is no longer active",
    description: "This request was cancelled. Ask the person who sent it to create a new one.",
  },
};

const MISSING_TOKEN: RequestError = {
  heading: "Missing link",
  description:
    "This URL is missing the document request token. Check that the full link was copied from the email.",
};

const NETWORK_ERROR: RequestError = {
  heading: "Something went wrong",
  description: "We had trouble loading this request. Please try again in a moment.",
};

const INVALID_TOKEN: RequestError = {
  heading: "Invalid link",
  description:
    "This document request link is not valid or has been replaced. Ask the person who sent it to create a new one.",
};

export function getRequestError(opts: {
  token: string;
  isNetworkError: boolean;
  serverError: string | null;
}): RequestError {
  if (!opts.token) return MISSING_TOKEN;
  if (opts.isNetworkError) return NETWORK_ERROR;
  return VALIDATION_ERRORS[opts.serverError ?? ""] ?? INVALID_TOKEN;
}
